import * as actionsTypes from './../types/clientTypes'

export const addClient = (clientInfo) => {
    return {
        type: actionsTypes.ADD_CLIENT,
        payload: {
            client: clientInfo,
        }
    }
}

export const updateLanguage = (languageChoice) => {
    return {
        type: actionsTypes.UPDATE_LANGUAGE,
        payload: {
            language: languageChoice,
        }
    }
}